import { styled } from '@mui/material';

export const Subtitle = styled('p')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '157%',
  marginTop: 10,
  marginBottom: 0,
}));
